import { IInteriorOrganizerPlacesResponse } from '../../interior-organizer-interfaces';

export const getFilteredPlaces = (
    storagePlacesData: IInteriorOrganizerPlacesResponse,
    filterWidth: number,
    filterHeight: number,
    filterDepth: number,
    filterName: string,
) => {
    let places = storagePlacesData?.places || [];

    places = places.filter(place => {

        const placeWidth = place.width || 0;
        const placeHeight = place.height || 0;
        const placeDepth = place.depth || 0;

        const isPlaceWidthMatch = placeWidth >= filterWidth;
        const isPlaceHeightMatch = placeHeight >= filterHeight;
        const isPlaceDepthMatch = placeDepth >= filterDepth;
        const isPlaceNameMatch = filterName.trim() === '' || place.name.toLowerCase().includes(filterName.trim().toLowerCase());

        return isPlaceWidthMatch &&
            isPlaceHeightMatch &&
            isPlaceDepthMatch &&
            isPlaceNameMatch;
    });

    return places;
};